module.exports = __webpack_public_path__ + "static/media/location-pointer.da112c56.svg";